"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentLegacyProcessor = void 0;

var __1 = require("..");

var Session_1 = require("./Session");

var PaymentLegacyProcessor =
/** @class */
function () {
  function PaymentLegacyProcessor(env, sessionId, sessionData, billingContact, paymentMethod) {
    this.sessionId = sessionId;
    this.legacySession = new Session_1.PaymentLegacySession(env, sessionId, sessionData, billingContact);
    this.paymentMethod = paymentMethod;
  }

  PaymentLegacyProcessor.isLegacyRequest = function (session) {
    return /^[SV][a-zA-Z0-9]{32}$/.test(session.paymentCommunicator.sessionId);
  };

  PaymentLegacyProcessor.prototype.processLegacyPayment = function (paymentClient) {
    return __awaiter(this, void 0, void 0, function () {
      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.paymentMethod;

            switch (_a) {
              case __1.PaymentMethod.creditCard:
                return [3
                /*break*/
                , 1];

              case __1.PaymentMethod.ACH:
                return [3
                /*break*/
                , 3];

              case __1.PaymentMethod.eCheck:
                return [3
                /*break*/
                , 5];

              case __1.PaymentMethod.ePaperToken:
                return [3
                /*break*/
                , 7];

              case __1.PaymentMethod.notPresent:
                return [3
                /*break*/
                , 9];
            }

            return [3
            /*break*/
            , 10];

          case 1:
            this.creditCardInfo = paymentClient.creditCardInfo;

            if (!this.creditCardInfo) {
              throw new __1.PaymentValidationError("Credit Card Information is not present", __1.PaymentErrorShortCodes.missing_credit_card);
            }

            return [4
            /*yield*/
            , this.legacySession.processLegacyCreditCardPayment(this.creditCardInfo)];

          case 2:
            return [2
            /*return*/
            , _b.sent()];

          case 3:
            this.achInfo = paymentClient.achInfo;

            if (!this.achInfo) {
              throw new __1.PaymentValidationError("ACH Information is not present", __1.PaymentErrorShortCodes.missing_ach);
            }

            return [4
            /*yield*/
            , this.legacySession.processLegacyACHPayment(this.achInfo)];

          case 4:
            return [2
            /*return*/
            , _b.sent()];

          case 5:
            this.eCheckInfo = paymentClient.eCheckInfo;

            if (!this.eCheckInfo) {
              throw new __1.PaymentValidationError("eCheck Information is not present", __1.PaymentErrorShortCodes.missing_echeck);
            }

            return [4
            /*yield*/
            , this.legacySession.processLegacyECheckPayment(this.eCheckInfo)];

          case 6:
            return [2
            /*return*/
            , _b.sent()];

          case 7:
            this.ePaperTokenInfo = paymentClient.ePaperTokenInfo;

            if (!this.ePaperTokenInfo) {
              throw new __1.PaymentValidationError("ePaper Token Information is not present", __1.PaymentErrorShortCodes.missing_epaper_token);
            }

            return [4
            /*yield*/
            , this.legacySession.processLegacyEPaperTokenPayment(this.ePaperTokenInfo)];

          case 8:
            return [2
            /*return*/
            , _b.sent()];

          case 9:
            {
              throw new __1.PaymentValidationError("Payment Method is not present, make sure to add credit card info or other billing info", __1.PaymentErrorShortCodes.missing_payment_method);
            }
            _b.label = 10;

          case 10:
            {
              throw new __1.PaymentClientError("Payment Method is not supported", __1.PaymentErrorShortCodes.unsupported_payment_method);
            }
            _b.label = 11;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return PaymentLegacyProcessor;
}();

exports.PaymentLegacyProcessor = PaymentLegacyProcessor;


// WEBPACK FOOTER //
// ./node_modules/@backoffice/fast-payments-client-js-sdk/build/src/PaymentClient/Legacy/PaymentLegacyProcessor.js